import { render, staticRenderFns } from "./JournalLog.vue?vue&type=template&id=eb22714c&scoped=true&"
import script from "./JournalLog.vue?vue&type=script&lang=js&"
export * from "./JournalLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb22714c",
  null
  
)

export default component.exports